var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbNrGeneralRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    opacity: 0.2,
    transform: "translate(-937 -1003) translate(937 1003)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.127 3.564V2H0v18.762h9.7a5.838 5.838 0 0 1-1.865-3.909H3.127v-.782h4.715a5.832 5.832 0 0 1 .658-2.345H3.127v-.782H9a5.848 5.848 0 0 1 7.419-1.666V2H13.29v1.564h-.782V2h-2.345v1.564h-.782V2H7.036v1.564h-.782V2H3.909v1.564zM13.29 10.6H3.127v-.782H13.29zm0-3.909v.782H3.127v-.782z",
    transform: "translate(-937 -1003) translate(940.01 1004.488) translate(0 -.436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H0.782V1.564H0z",
    transform: "translate(-937 -1003) translate(940.01 1004.488) translate(3.127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H0.782V1.564H0z",
    transform: "translate(-937 -1003) translate(940.01 1004.488) translate(6.254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H0.782V1.564H0z",
    transform: "translate(-937 -1003) translate(940.01 1004.488) translate(9.381)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H0.782V1.564H0z",
    transform: "translate(-937 -1003) translate(940.01 1004.488) translate(12.508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.081 14a5.081 5.081 0 1 0 5.081 5.081A5.081 5.081 0 0 0 16.081 14zm-1.105 7.569l-2.212-2.211.553-.553 1.658 1.658 3.87-3.869.553.553z",
    transform: "translate(-937 -1003) translate(940.01 1004.488) translate(-2.401 -3.055)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbNrGeneralRules);
export default __webpack_public_path__ + "static/media/rb-nr-general-rules.b99db299fc2392640f21bf6a75038814.svg";
export { ForwardRef as ReactComponent };